<template>
  <b-navbar class="main-navbar p-0 pr-3">

    <span :class="{collapsed: isCollapsed}" class="toggle-menu-btn text-white hover-cursor ml-3"
          @click="toggleMenu">
      <font-awesome-icon icon="bars"/>
    </span>

    <div class="ml-3">
      <router-link to="/">
        <img v-if="!isXmas" src="@/assets/horizontal_logo.png" style="max-height: 50px;max-width: 97px"/>
        <img v-else src="@/assets/horizontal_logo_xmas.png" style="max-height: 50px;max-width: 97px"/>
      </router-link>
    </div>

    <div class="ml-auto d-flex align-items-center">

      <navbar-qr-scan-button class="ml-auto"/>

      <div v-if="currentBranch" class="text-white branch-name">
        <template v-if="currentBranches && currentBranches.length === 0">
          <span class="text-white ml-3 mr-3">
            {{ currentBranch.name }}
          </span>
        </template>
        <template v-else>
          <b-dd right variant="outline" class="text-white">
            <template #button-content>
              <span class="text-white">
                {{ currentBranch.name }}
              </span>
            </template>
            <b-dd-item v-for="item in currentBranches" :key="item.uuid" @click="selectBranch(item.uuid)">
              {{ item.name }}
            </b-dd-item>
          </b-dd>
        </template>
      </div>

      <navbar-actions/>

    </div>

  </b-navbar>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import NavbarNotifications from "@/core/components/navbar/NavbarNotifications";
  import NavbarQrScanButton from "@/core/components/navbar/NavbarQrScanButton";
  import NavbarActions from "@/core/components/navbar/NavbarActions";
  import http from "@/core/services/http.service";
  import UserService from "@/modules/setup/user/UserService";

  const {mapState, mapActions} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "Navbar",
    components: {NavbarActions, NavbarQrScanButton, NavbarNotifications},
    data() {
      return {
        isXmas: false
      }
    },
    methods: {
      ...mapActions(['updateMenuCollapsed', 'updateGlobalLoader']),
      toggleMenu() {
        this.updateMenuCollapsed(!this.isCollapsed);
      },
      async selectBranch(uuid) {
        let response = await UserService.switchBranch({uuid: uuid})
        if (response.success) {
          this.updateGlobalLoader(false);
          setTimeout(() => {
            this.$router.push('/customers');
            this.$router.go();
          }, 200)
        } else {
          this.$errorDialog(response.toastError);
        }
      }
    },
    computed: {
      ...mapState({
        isCollapsed: state => state.menu.collapsed,
        currentBranch: state => state.currentBranch,
        currentUser: state => state.currentUser
      }),
      currentBranches() {
        if (!this.currentUser || !this.currentUser.branches) {
          return [];
        }
        return this.currentUser.branches.filter(b => b.uuid !== this.currentBranch.uuid);
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "./../../scss/variables";

  .navbar {
    padding-left: 0;
    background: $header-bg;
    border-bottom-color: $header-border-color;
    height: 3.1em;

    .toggle-menu-btn {
      font-size: 1.3em;
      transition: .3s;
      -webkit-transition: .3s;
      -moz-transition: .3s;
      -o-transition: .3s;

      &.collapsed {
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
      }
    }

    .navbar-brand {
      color: $header-navbar-brand-color;
      font-size: $header-navbar-brand-font-size;
    }

    .branch-name {
      a {
        color: $header-navbar-brand-color;
      }
    }
  }
</style>
